import { ResolutionString } from 'public/assets/charting_library/charting_library';
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

type ThemeState = {
  selectedResolution: ResolutionString;
  selectedSimpleResolution: ResolutionString;
  setSelectedResolution: (selectedResolution: ResolutionString) => void;
  setSelectedSimpleResolution: (selectedSimpleResolution: ResolutionString) => void;
};

const useTradingViewChartStore = create<ThemeState>()(
  persist(
    (set) => ({
      selectedResolution: '1D' as ResolutionString,
      selectedSimpleResolution: '1D' as ResolutionString,

      setSelectedResolution: (selectedResolution: ResolutionString) => {
        set({ selectedResolution });
      },

      setSelectedSimpleResolution: (selectedSimpleResolution: ResolutionString) => {
        set({ selectedSimpleResolution });
      },
    }),
    {
      name: 'tradingview-store',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

export { useTradingViewChartStore };
